import { createSlice } from '@reduxjs/toolkit';

import store from './store';

import endPoints from '../api/endpoint';
import { getApiCall, postApiCall } from '../api/methods';

import { Schedular } from '../types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const initialState: Schedular = {
  loading: false,
  schduleList: [],
};

const schedularSlice = createSlice({
  name: 'schdular',
  initialState,
  reducers: {
    updateLoader: (state: Schedular, action: { payload: boolean }) => {
      state.loading = action.payload;
    },
    updateSchduleList: (state: Schedular, action: { payload: any }) => {
      state.schduleList = action.payload;
    },
  },
});

export const { updateLoader, updateSchduleList } = schedularSlice.actions;

export default schedularSlice.reducer;

export const getScheduleCalendar = (
  {
    selectedDate,
    regionIds,
    productionIds,
    episodeIds,
    setIds,
    vendorIds,
    vendorOrderStatus,
  }: {
    selectedDate: any;
    regionIds: any;
    productionIds: any;
    episodeIds: any;
    setIds: any;
    vendorIds: any;
    vendorOrderStatus: any;
  },
  cb?: any,
) => {
  const { dispatch } = store;

  // console.log('selectedDate=>>>', selectedDate);

  const date = dayjs(selectedDate);
  const month = date.month() + 1; // dayjs months are 0-indexed
  const year = date.year();

  const payload = {
    month: month,
    year: year,
    ...(regionIds && { regionIds: regionIds }),
    ...(productionIds && { productionIds: productionIds }),
    ...(episodeIds && { episodeIds: episodeIds }),
    ...(setIds && { setIds: setIds }),
    ...(vendorIds && { vendorIds: vendorIds }),
    ...(vendorOrderStatus && { vendorOrderStatus: vendorOrderStatus }),
  };

  // Append month and year to query
  // const updatedQuery = `?month=${month}&year=${year}`;

  const apiEndPoint = endPoints.schedule.scheduleCalendar;

  postApiCall(
    apiEndPoint,
    payload,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateSchduleList(data.data));

        if (cb) cb(data?.data); // Call the callback function if provided
      }
      // dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      cb && cb();

      // dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getScheduleList = (
  selectedDate: any,
  query: any = '?page=1&limit=10',
  cb?: any,
) => {
  const { dispatch } = store;

  console.log('selectedDate==========>>>', selectedDate);
  console.log('selectedDate type==========>>>', typeof selectedDate);

  // Handle different types of selectedDate input
  // let year, month, day;

  // if (typeof selectedDate === 'string') {
  //   [year, month, day] = selectedDate.split('-').map(Number);
  // } else if (selectedDate instanceof Date) {
  //   year = selectedDate.getFullYear();
  //   month = selectedDate.getMonth() + 1; // getMonth() returns 0-11
  //   day = selectedDate.getDate();
  // } else if (dayjs.isDayjs(selectedDate)) {
  //   year = selectedDate.year();
  //   month = selectedDate.month() + 1; // dayjs month is 0-indexed
  //   day = selectedDate.date();
  // } else {
  //   console.error('Invalid selectedDate format:', selectedDate);
  //   return;
  // }

  // console.log('Parsed date components:', { year, month, day });

  // // Create timestamps in local timezone to avoid timezone issues
  // const startTimestamp = dayjs(
  //   `${year}-${month.toString().padStart(2, '0')}-${day
  //     .toString()
  //     .padStart(2, '0')}T00:00:00`,
  // ).valueOf();
  // const endTimestamp = dayjs(
  //   `${year}-${month.toString().padStart(2, '0')}-${day
  //     .toString()
  //     .padStart(2, '0')}T23:59:59.999`,
  // ).valueOf();

  // console.log('selectedDate=>>>', selectedDate);
  // console.log('startDate=>>>', startTimestamp);
  // console.log('endDate=>>>', endTimestamp);
  // console.log('startDate as date=>>>', new Date(startTimestamp).toISOString());
  // console.log('endDate as date=>>>', new Date(endTimestamp).toISOString());
  // console.log(
  //   'startDate as local date=>>>',
  //   new Date(startTimestamp).toString(),
  // );
  // console.log('endDate as local date=>>>', new Date(endTimestamp).toString());

  // query += `&startDate=${startTimestamp}&endDate=${endTimestamp}`;

  // const apiEndPoint = endPoints.schedule.scheduleList + query;
  // dispatch(updateLoader(true)); // Show loader before the API call

  // -----------APPROACH 1-----------

  // const dateToTimestamp = (date: Date) => {
  //   return date.getTime();
  // };

  // const date = new Date(selectedDate);

  // date.setHours(new Date().getHours());
  // date.setMinutes(new Date().getMinutes());
  // date.setSeconds(new Date().getSeconds());

  // const timestamp = dateToTimestamp(date);
  // const newDate = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000);

  // const endTimeStamp = dateToTimestamp(newDate);

  const startTimestamp = dayjs
    .utc(`${dayjs(selectedDate).format('YYYY-MM-DD')}T00:00:00`)
    .valueOf();

  const endTimestamp = dayjs
    .utc(`${dayjs(selectedDate).format('YYYY-MM-DD')}T23:59:59.999`)
    .valueOf();

  query += `&startDate=${startTimestamp}&endDate=${endTimestamp}`;

  const apiEndPoint = endPoints.schedule.scheduleList + query;

  // -----------APPROACH 1-----------

  getApiCall(
    apiEndPoint,

    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateSchduleList(data.data));

        if (cb) cb(data?.data?.[0]); // Call the callback function if provided
      }
      // dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      cb && cb();

      // dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getScheduleFilterList = (
  query = '?page=1&limit=10',
  type: string,
  cb?: any,
) => {
  const { dispatch } = store;

  const apiEndPoint = `${
    endPoints.schedule.scheduleFilter + query
  }&entityType=${type}`;

  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // dispatch(updateSchduleList(data.data));

        if (cb) cb(data?.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      cb();

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};
